import React from "react";
import { motion } from "framer-motion";
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  y = 24,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-80px"
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-377" data-mp="3bie77s7pl1q6">
      {children}
    </motion.div>;
}